import { createSelector } from 'reselect';
import { RootState } from '../../../store';
import { getPricelists } from '../../pricelist/redux/pricelistSelectors';

const getSelectedCalculationPricelistId = (state: RootState) =>
    state.calculation.selectedCalculationPricelist;
export const getSelectedCalculationPricelistCurrency = createSelector(
    [getPricelists, getSelectedCalculationPricelistId],
    (pricelists, selectedPricelistId) => {
        return pricelists[selectedPricelistId].currency;
    }
);

export const getCalculations = (state: RootState) => state.calculation.calculations;
